export const RESET_BOOKING_TREE_STATE = "RESET_BOOKING_TREE_STATE";
export const ADD_BOOKING_TIP_SUGGESTION = "ADD_BOOKING_TIP_SUGGESTION";
export const SET_BOOKING_TREE_ITEMS = "SET_BOOKING_TREE_ITEMS";
